<template>
  <v-layout column fill-height>
    <div class="flex relative grow shrink-0">
      <div class="maincontent console ma-1 flex flex-col" style="border-bottom: 1px solid #ccc">
        <div class="!flex flex-wrap !grow-0 w-full">
          <div class="!flex !grow-4">
            <div class="centercontent grow-0" style="width: 64px">
              <span style="font-weight: bold">{{ $t('Pilot.MissionConsole.Date') }}</span>
            </div>
            <div class="centercontent grow-0" style="width: 90px">
              <span style="font-weight: bold">{{ $t('Pilot.MissionConsole.Time') }}</span>
            </div>
            <div class="centercontent grow-0" style="width: 46px">
              <span style="font-weight: bold">{{ $t('Pilot.MissionConsole.FromTo') }}</span>
            </div>
            <div class="centercontent grow-0" style="width: 40px">
              <span style="font-weight: bold">{{ $t('Pilot.MissionConsole.Cycle') }}</span>
            </div>
            <div class="centercontent grow-0" style="width: 40px">
              <span style="font-weight: bold">{{ $t('Pilot.MissionConsole.Message') }}</span>
            </div>
          </div>
          <div class="!flex items-center justify-end justify-items-end !grow">
            <v-btn small @click="downloadFile(`/api/log/console/csv/?misid=${mission.misId}`)" color="primary">
              {{ $t('Pilot.MissionConsole.DownloadAllConsoleLog') }}
              <v-icon small class="pl-2">mdi-download</v-icon>
            </v-btn>
            <v-btn
              icon
              exact
              @click="autoScroll = !autoScroll"
              :title="$t(autoScroll ? 'Pilot.MissionConsole.AutoScroll' : 'Pilot.MissionConsole.AutoScrollDisabled')"
            >
              <v-icon v-text="autoScroll ? 'mdi-arrow-expand-vertical' : 'mdi-arrow-vertical-lock'" />
            </v-btn>
            <mission-detail-console-filter :mission="mission" />
          </div>
        </div>
        <div class="!flex !grow relative">
          <div ref="list" class="maincontent" style="overflow: none" v-resize="onResize">
            <!-- {{ consoleMsgsFiltered.map(m => m.wobTrmId || -10) }} -->
            <DynamicScroller
              ref="console"
              :style="{ height: `${height}px`, overflow: 'auto' }"
              class="scroller"
              :items="consoleMsgsFiltered"
              :min-item-size="24"
              :buffer="200"
              keyField="wobTrmId"
              :emitUpdate="true"
              @update="memoScroll"
            >
              <template #before>
                <v-layout row wrap style="flex: 1 0; align-items: flex-start" v-if="missionState">
                  <v-flex xs6 class="centercontent">
                    <v-btn small style="width: 99%" @click.prevent="loadMore()" color="primary">
                      {{ $t('Pilot.MissionConsole.LoadMoreData') }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 class="centercontent">
                    <v-btn small style="width: 99%" @click.prevent="loadMore(true)" color="primary">
                      {{ $t('Pilot.MissionConsole.LoadAllData') }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 v-if="consoleMsgsLoading">
                    <v-progress-linear indeterminate color="primary"></v-progress-linear>
                  </v-flex>
                </v-layout>
              </template>
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem :item="item" :active="active" :data-index="index">
                  <mission-detail-console-row :rowItem="item" />
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mission.misActifOn && !readonly" class="!flex grow-0 flex-wrap w-full px-1">
      <div class="grow-[10] mb-2">
        <glider-cmd-input
          ref="inputCmd"
          v-model="command"
          @validSaisie="sendCommand()"
          :label="$t('Pilot.MissionConsole.Command')"
          :gliderFabricant="mission.gliFabricant"
        />
      </div>
      <div class="!flex items-center justify-end justify-items-end !grow">
        <v-btn color="primary" :disabled="cmdSending" :loading="cmdSending" @click="sendCommand()">
          {{ $t('Pilot.MissionConsole.Send') }}
        </v-btn>
        <v-btn @click="$store.myActions.MISSION_CLEAR_CONSOLE(mission.misId)">
          {{ $t('Pilot.MissionConsole.Clear') }}
        </v-btn>
      </div>
    </div>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import MissionDetailConsoleRow from '@/components/mission/MissionDetailConsoleRow'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import types from '@/store/all-mutation-types'
import apiHelpers from '@/utils/api'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { GliderCmd } from '@/models/datapool/GliderCmd'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import GliderCmdInput from '@/components/shared/GliderCmdInput.vue'
import MissionDetailConsoleFilter from '@/components/mission/MissionDetailConsoleFilter.vue'
import { AloMission } from '@/models/alo/AloMission'
import { readonly } from 'vue'

export default {
  name: 'MissionDetailConsole',
  components: { MissionDetailConsoleRow, GliderCmdInput, MissionDetailConsoleFilter },
  props: {
    isleft: Boolean,
    uiid: {
      type: String,
      required: true,
    },
    isVisible: Boolean,
    mission: AloMission,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      command: '',
      loadMorePending: false,
      modConfEnable: false,
      cmdSending: false,
      height: 100,
      nbLineBeforeLoadMore: 0,
    }
  },
  computed: {
    ...mapGetters(['missionUiStateByUiid', 'userSecurity', 'currentDetailMission']),
    missionState() {
      return this.missionUiStateByUiid(buildMissionUIStateId(this.mission.misId, 'detail'))
    },
    infosPanelVisible() {
      return this.missionState.infosPanelVisible
    },
    leftPanelWidth() {
      return this.currentDetailMission.leftPanelWidth
    },
    consoleMsgs() {
      return this.missionState.consoleMsgs
    },
    consoleMsgsFiltered() {
      return this.consoleMsgs?.filter(r => this.consoleGdbFilter?.every(f => r?.gdbType != f) ?? true) ?? []
    },
    consoleGdbFilter() {
      return this.missionState.consoleGdbFilter ?? []
    },
    consoleMsgsLoading() {
      return this.missionState.consoleMsgsLoading
    },
    accesModConfFilter() {
      return this.userSecurity[SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER]
    },
    autoScroll: {
      get() {
        return this.missionState.consoleAutoScroll
      },
      set(newValue) {
        this.$store.myActions.UI_SET_CONSOLE_AUTOSCROLL({
          autoScroll: newValue,
          uiid: buildMissionUIStateId(this.mission.misId, 'detail'),
        })
      },
    },
    oldScrollIndex: {
      get() {
        return this.missionState.consoleScrollIndex
      },
      set(newValue) {
        this.$store.myActions.UI_SET_CONSOLE_SCROLLINDEX({
          index: newValue,
          uiid: buildMissionUIStateId(this.mission.misId, 'detail'),
        })
      },
    },
  },
  created() {
    this.$store.myActions.UI_ENABLE_CONSOLE_MSG(this.mission.misId)
  },
  mounted() {
    this.onResize()
    if (this.$refs.console) {
      this.$nextTick(() => {
        this.$refs.console.scrollToBottom()
      })
    }
  },
  watch: {
    infosPanelVisible(newValue) {
      this.onResize()
    },
    consoleMsgsFiltered(newValue) {
      if (this.$refs.console) {
        if (!this.loadMorePending) {
          if (this.missionState.consoleAutoScroll) {
            this.$nextTick(() => {
              this.$refs.console.scrollToBottom()
            })
          }
        } else {
          this.$nextTick(() => {
            this.$refs.console.scrollToItem(this.consoleMsgsFiltered.length - this.nbLineBeforeLoadMore)
          })
        }
        this.loadMorePending = false
      }
    },
    leftPanelWidth() {
      this.onResize()
    },
    isVisible(newValue, oldValue) {
      this.onResize()
    },
  },
  methods: {
    onResize(step = 0) {
      if (this.$refs.list) this.height = this.$refs.list.clientHeight
      if (step == 0) {
        setTimeout(() => {
          this.onResize(step + 1)
        }, 250)
      }
      if (step == 1) {
        setTimeout(() => {
          this.onResize(step + 1)
        }, 500)
      }
      if (step == 2) {
        setTimeout(() => {
          this.onResize(step + 1)
        }, 1000)
      }
    },
    async sendCommand() {
      if (!this.cmdSending) {
        this.command = this.cleanCommande(this.command)
        await this.$nextTick()
        if (this.$refs.inputCmd) {
          if (!(await this.$refs.inputCmd.checkSaisie())) return
        }
        this.cmdSending = true
        this.$store.myActions
          .GLIDER_SEND_IRIS_COMMAND_REQUEST({ gliId: this.mission.gliId, command: this.command })
          .then(() => {
            this.$nextTick(() => (this.command = ''))
          })
          .catch(error => {
            let errMsg = 'BAD COMMAND'
            if (error?.errorMessage) {
              errMsg = error.errorMessage
              if (error.internalErrorMessage) {
                const data = error.internalErrorMessage.split('Iris Response = ')
                if (data.length == 2) {
                  const irisResponse = JSON.parse(data[1])
                  //if(irisResponse?.result_msg) errMsg += `: ${irisResponse.result_msg}`
                  if (irisResponse?.result_msg) errMsg = irisResponse.result_msg
                }
              }
            }
            this.$store.myActions.UI_ADD_SNACK_MESSAGE(errMsg)
          })
          .finally(() => {
            this.cmdSending = false
          })
      }
    },
    memoScroll(startIndex, endIndex, visibleStartIndex, visibleEndIndex) {
      //on memorise seulement si on est pas en cours de loading more
      this.oldScrollIndex = visibleStartIndex
    },
    cleanCommande(cmd) {
      let corrected = cmd.replace(/ /g, '')
      if (!corrected.endsWith(';')) corrected = `${corrected};`
      return corrected
    },
    loadMore(all) {
      this.loadMorePending = true
      this.nbLineBeforeLoadMore = this.consoleMsgsFiltered.length - 1
      let stop = this.consoleMsgs.length > 0 ? this.consoleMsgs[0].wobTrmId : null
      this.$store.myActions.UI_LOAD_CONSOLE_MSG_REQUEST({ id: this.mission.misId, stop, nb: all ? undefined : 50 })
    },
    downloadFile(url) {
      apiHelpers.downloadFile(url)
    },
  },
}
</script>
<style>
.mod-conf .v-input__slot {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.vue-recycle-scroller__item-wrapper {
  min-width: 1000px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.liste {
  flex: 1 1 auto;
  overflow: hidden;
  height: min-content;
}

table {
  width: 100%;
  display: table;
}

.centercontent {
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  text-align: center;
  min-width: min-content;
  flex-shrink: 0;
}

.console {
  font-size: 12px;
}

.hover {
  background-color: #00000022;
}

tbody {
  height: 25em; /* 5 times the equivalent of a text "size". */
  overflow-y: scroll;
}
</style>
